import { useMutation } from "react-query";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { HelpWidgetMessage } from "../types/help_widget_message";

interface UseCreateChatMessageProps {
  onError: (error: unknown) => void;
  onSuccess: (message: HelpWidgetMessage) => void;
}

interface CreateChatMessageParams {
  attachment_ids?: string[];
  conversationId: string;
  text: string;
}

export const useCreateChatMessage = ({
  onSuccess,
  onError,
}: UseCreateChatMessageProps) =>
  useMutation<{ message: HelpWidgetMessage }, unknown, CreateChatMessageParams>(
    {
      mutationFn: async ({
        conversationId,
        text,
        attachment_ids = [],
      }: CreateChatMessageParams) =>
        reactQueryPost(
          internalApi.helpWidget.createChatMessage({ id: conversationId }),
          {
            text,
            attachment_ids,
          },
        ),
      onSuccess: data => {
        onSuccess(data.message);
      },
      onError,
    },
  );
